import { post, get, del, put, patch } from '../admin';

export const createAdminPostEndpoint = (path) => (data) => post(`/v1/${path}`, { data });
export const createAdminGetEndpoint = (path) => (data) => get(`/v1/${path}`, { data });
export const createAdminDeleteEndpoint = (path) => (data) => del(`/v1/${path}`, { data });
export const createAdminPutEndpoint = (path) => (data) => put(`/v1/${path}`, { data });
export const createAdminPatchEndpoint = (path) => (data) => patch(`/v1/${path}`, { data });
